import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Plus, Minus, ArrowRight } from 'lucide-react';
import { createPageUrl } from '@/utils';
import { faqs } from '@/pages/FAQs';
import { Tile, Eyebrow, BTN_INVERT } from '@/components/bento';

const TOP_FAQS = faqs.slice(0, 5);

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faqs" className="bg-zinc-950 py-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 grid grid-cols-1 gap-4 lg:grid-cols-12">
        {/* Header tile */}
        <Tile className="lg:col-span-4 p-6 sm:p-8 flex flex-col">
          <Eyebrow>FAQ</Eyebrow>
          <h2 className="mt-5 text-3xl md:text-4xl font-extrabold tracking-[-0.04em] leading-[1.05] text-white">
            Questions, answered.
          </h2>
          <p className="text-zinc-400 mt-3 text-[15px] leading-relaxed">
            Quick answers about BuildersLab and the AI Builder.
          </p>
          <Link
            to={createPageUrl('FAQs')}
            className={`mt-8 lg:mt-auto inline-flex self-start items-center gap-2 h-11 px-5 rounded-full text-sm font-bold transition-colors ${BTN_INVERT}`}
          >
            See more FAQs <ArrowRight className="w-4 h-4" />
          </Link>
        </Tile>

        {/* Accordion — top 5, one tile each */}
        <div className="lg:col-span-8 space-y-3">
          {TOP_FAQS.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={faq.question}
                className={`rounded-3xl border bg-zinc-900 overflow-hidden transition-colors ${
                  isOpen ? 'border-zinc-700' : 'border-zinc-800 hover:border-zinc-700'
                }`}
              >
                <button
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  aria-expanded={isOpen}
                  className="w-full px-6 py-5 flex items-center justify-between text-left gap-6"
                >
                  <span className={`font-bold transition-colors ${isOpen ? 'text-white' : 'text-zinc-300'}`}>
                    {faq.question}
                  </span>
                  <span
                    className={`shrink-0 grid place-items-center w-8 h-8 rounded-full transition-colors ${
                      isOpen ? 'bg-orange-500 text-ink' : 'bg-zinc-800 text-zinc-400'
                    }`}
                    aria-hidden="true"
                  >
                    {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                  </span>
                </button>
                {isOpen && (
                  <div className="px-6 pb-6 -mt-1 text-zinc-400 leading-relaxed text-[15px]">
                    {faq.answer}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
